import React from "react";
import List from "../components/list";
import ListItem from "../components/list-item";
import Doctor from "../components/doctor";
import Spinner from "../components/spinner";
import View from "./view";
import messages from "../../../messages";
import config from "../../../config";

export default class DoctorView extends View {
    static get title() {
        return "выберите врача";
    }

    static get titleShort() {
        return "врач";
    }

    static get defaultProps() {
        return Object.assign({}, super.defaultProps, {
            service: null,
        });
    }

    static get propTypes() {
        return Object.assign({}, super.propTypes, {
            clinic: React.PropTypes.number.isRequired,
            specialization: React.PropTypes.number,
            service: React.PropTypes.string,
        });
    }

    constructor(props) {
        super(props);

        this.state = Object.assign({}, this.state, {
            items: null,
        });

        this._isMounted = false;
    }

    fetchData() {
        this.hideErrorMessage();
        this.setState({
            items: null
        });

        const service = this.props.service === null ? "0" : this.props.service;
        const clinic = this.props.clinic;


        const url = `${config.dataUrl}api.php?function=doctors` +
            `&clinic=${clinic}` +
            `&service=${service}`;

        fetch(url).then((response) => {
            return response.json();

        }).then((responseJson) => {
            if (this._isMounted === true) {
                if (responseJson.status === true) {
                    const sorted = responseJson.doctors.sort(
                        (a, b) => a.name.localeCompare(b.name));
                    this.setState({
                        items: sorted,
                    });
                } else {
                    this.showErrorMessage(responseJson.description);
                }
            }
        }).catch((error) => {
            if (this._isMounted === true) {
                this.showErrorMessage(messages["REQUEST_FAILED"]);
            }
        });
    }

    componentDidMount() {
        this._isMounted = true;
        this.fetchData();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    handleRetryClick() {
        this.fetchData();
    }

    renderContent() {
        if (this.state.isErrorMessageVisible === true) {
            return this.renderErrorMessage();
        }

        if (this.state.items === null) {
            return <Spinner/>;
        }

        let nextView = null;
        if (this.props.service === null) {
            nextView = "ServiceView";
        } else {
            nextView = "DateView";
        }

        let key = 0;
        const elements = [];
        for (const doctor of this.state.items) {
            elements.push(
                <ListItem key={key++} isActive={true} onClick={() => {
                    const props = {
                        doctor: doctor.id,
                    };

                    this.props.gotoNextView({
                        breadcrumbName: doctor.name,
                        nextView: nextView,
                        props: props
                    });
                }}>

                    <Doctor
                        name={doctor.name}
                        photoUrl={doctor.photoUrl}
                        tags={{
                            price: parseInt(doctor.price, 10),
                            seesChildren: (doctor.seesChildren),
                            seesAdult: (doctor.seesAdult)
                        }}/>
                </ListItem>
            );
        }

        return <List>{elements}</List>;
    }

    render() {
        return (
            <div className="appointment-view appointment-view--doctor">
                {this.renderContent()}
            </div>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/widgets/appointment-widget/views/doctor.js
 **/